import { useRef } from 'react';
import { Button, HiddenInput } from 'ui';
import { DescriptionOutlined } from 'ui/icons';

type Props = {
  onFileSelected: (file: File) => void;
  disabled?: boolean;
  text?: string;
};

export const AddGenericDocumentButton = ({ onFileSelected, disabled, text = 'Add Document' }: Props) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  return (
    <>
      <Button
        variant="secondary"
        disabled={disabled}
        onClick={() => fileInputRef.current?.click()}
        startIcon={<DescriptionOutlined />}
        data-testid={'add_document_button'}
      >
        {text}
      </Button>
      <HiddenInput
        multiple={false}
        ref={fileInputRef}
        type="file"
        onChange={(event) => {
          if (!event.target.files?.length) {
            return;
          }
          onFileSelected(event.target.files[0]);
        }}
      />
    </>
  );
};
